import { render } from "./sub-menu-garderob.vue?vue&type=template&id=3dd655ac"
import script from "./sub-menu-garderob.vue?vue&type=script&lang=js"
export * from "./sub-menu-garderob.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ian/codebase/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__